<script setup lang="ts">
import VehicleOption from '~/components/vehicle/vehicle-card/common/VehicleOption.vue'
import { useBuildSeries } from '~/composables/build-series'
import { translate } from '~/composables/translate/translations'

const props = defineProps<{ buildSeries?: string }>()

const {
  engineTypeTranslation,
  engineTypeIcon,
  gearTypeTranslation,
  gearTypeIcon,
  seatsTranslation,
  minimumAgeTranslation,
} = useBuildSeries(props.buildSeries)
</script>

<template>
  <footer class="grid grid-cols-2 xl:gap-x-32 gap-y-6 xs:gap-y-8 text-sm">
    <VehicleOption icon-name="seat_filled" :info="seatsTranslation()" />
    <VehicleOption :icon-name="engineTypeIcon()" :info="engineTypeTranslation()" />
    <VehicleOption icon-name="location_filled" :info="translate('extra_cat_detail_navigation')" />
    <VehicleOption :icon-name="gearTypeIcon()" :info="gearTypeTranslation()" />
    <VehicleOption icon-name="lock_open_filled" :info="minimumAgeTranslation()" />
    <VehicleOption icon-name="sun_filled" :info="translate('extra_cat_detail_air_conditioning')" />
  </footer>
</template>
